export type SubscriptionTier = 'free' | 'pro';

export interface TierLimits {
  projects: number | 'unlimited';
  episodes: number | 'unlimited';
  autoTranscriptions: number | 'unlimited';
  autoTranslations: number | 'unlimited';
}

export interface TierInfo {
  id: SubscriptionTier;
  name: string;
  price: number; // in dollars
  priceId?: string; // Dodo Payments price ID
  interval: 'month';
  description: string;
  limits: TierLimits;
  features: string[];
  popular?: boolean;
}

export const SUBSCRIPTION_TIERS: Record<SubscriptionTier, TierInfo> = {
  free: {
    id: 'free',
    name: 'Free',
    price: 0,
    interval: 'month',
    description: 'Perfect for trying out Scribelate',
    limits: {
      projects: 3,
      episodes: 20,
      autoTranscriptions: 10,
      autoTranslations: 15,
    },
    features: [
      '3 projects',
      '20 podcast episodes',
      '10 auto-transcriptions/month',
      '15 auto-translations/month',
      'Manual transcription & translation',
      'Audio segments & loops',
      'YouTube video study',
    ],
  },
  pro: {
    id: 'pro',
    name: 'Pro',
    price: 4.99,
    priceId: 'pdt_0NX0y0V5SA06CVdkIbRRi',
    interval: 'month',
    description: 'For serious language learners',
    popular: true,
    limits: {
      projects: 'unlimited',
      episodes: 'unlimited',
      autoTranscriptions: 'unlimited',
      autoTranslations: 'unlimited',
    },
    features: [
      'Unlimited projects',
      'Unlimited podcast episodes',
      'Unlimited auto-transcriptions',
      'Unlimited auto-translations',
      'Priority support',
      'All Free features',
    ],
  },
};

// Helper function to check if a limit is reached
export const isLimitReached = (used: number, limit: number | 'unlimited'): boolean => {
  if (limit === 'unlimited') return false;
  return used >= limit;
};

// Helper function to get remaining quota
export const getRemainingQuota = (used: number, limit: number | 'unlimited'): number | 'unlimited' => {
  if (limit === 'unlimited') return 'unlimited';
  return Math.max(0, limit - used);
};

// Helper function to format limit display
export const formatLimit = (limit: number | 'unlimited'): string => {
  return limit === 'unlimited' ? 'Unlimited' : limit.toString();
};
